import { getBlockerStyle } from './shared-styles-from-theme-fluent';

export const uurlTestToolStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .uurl-test-tool__container': {
    paddingLeft: 0,
    marginLeft: 0,

    '& .glyph-status-ok, & .status_warning, & .glyph-info': {
      fontFamily: iconFontFamily,
      fontSize: 16,
      lineHeight: '16px',
    },

    '& .glyph-status-ok:before': {
      color: '#107C10',
      content: '"\\E930"',
      verticalAlign: 'middle',
    },

    '& .status_warning:before': {
      color: '#D83B01',
      content: '"\\E7BA"',
      verticalAlign: 'middle',
    },

    '& .glyph-info:before': {
      color: '#605E5C',
      content: '"\\E946"',
    },
  },

  '& .uurl-test-info__container .uurl-test-info': {
    '-ms-grid-row': '3',
    alignItems: 'center',
    display: 'flex',
    marginTop: 4,

    '& .loading-image': Object.assign({
      display: 'inline-block',
      margin: '8px 2px',
      flexShrink: 0,
      flexGrow: 0,
    }, getBlockerStyle(28, palette)),

    '& .resultString': {
      borderBottom: '1px dashed #0078D4',
      marginLeft: 7,
    },

    '& .detail-icon': {
      display: 'none !important',
    },

    '& .glyph-status-ok, & .status_warning, & .glyph-info': {
      fontFamily: iconFontFamily,
      fontSize: 16,
      lineHeight: '16px',
    },

    '& .glyph-status-ok:before': {
      color: '#107C10',
      content: '"\\E930"',
      verticalAlign: 'middle',
    },

    '& .status_warning:before': {
      color: '#D83B01',
      content: '"\\E7BA"',
      verticalAlign: 'middle',
    },

    '& .glyph-info:before': {
      color: '#605E5C',
      content: '"\\E946"',
    },
  },
});
